import ApiConection from "api_ref/ApiConection";
import UtilClass from "api_ref/UtilClass";
import Layout4Admin1 from "components/layout/Layout4Admin1";
import Css from './Customer.module.css';
import { useEffect, useState } from "react";
import ProfileUser from "./ProfileUser";
import { ToastError, ToastSuccess } from "components/MyControl";

export default function UserProfile(){

    const api = new ApiConection();
    const util = new UtilClass();

    const [loading, setLoading] = useState(true);
    const [user,setUser] = useState(undefined);
    const [alert, setAlert] = useState('');
    const [showToastSuccess, setShowToastSuccess] = useState(false);
    const [showToastError, setShowToastError] = useState(false);
    
    const userLoginSession = util.getSessionStorage('_dcaas_8089');

    const getUserLoginData = async () => {
        const response = await api.getData(`api/users/${userLoginSession.user_id}`);

        setLoading(true);
        if (response.status === true) {
            setUser(response.data);
        }
        setLoading(false);
    }

    const setUserData = async (Childdata) => {
        let request = {
            "first_name": Childdata.first_name,
            "last_name": Childdata.last_name,
            "tel": Childdata.tel,
            "email":Childdata.email,
        }

        //console.log(request);
        const response = await api.putData(`api/users/${userLoginSession.user_id}`, request);
        //console.log(response);
        if (response.status === false) {
            setAlert(response.message);
            setShowToastError(true);
        }
        else {
            setAlert('');
            getUserLoginData();
            setShowToastSuccess(true);
        }
    }

    useEffect(()=>{
        const fetchData = async()=>{
            await getUserLoginData();
        }

        fetchData();
    },[])

    return(
        <Layout4Admin1>
             {
                loading === false &&
                <div className={Css.Block_Transparent}>
                    <h3>ข้อมูลบัญชีของคุณ <i className="fa-solid fa-chevron-right"></i></h3>
                    <div className='contrainer'>
                        <ProfileUser data={user} callSubmitParentData={setUserData} parentAlert={alert} openEmail={true} />
                        
                    </div>
                </div>
            }
            {
                loading === true &&
                <div className={Css.Block_Transparent + ' placeholder-glow'}>
                    <h3 className="placeholder rounded col-12"></h3>
                    <div className='contrainer'>
                        <div className='mt-3 mb-3'>
                            <div className={`border rounded p-4 bg-white shadow w-100`}>
                                <span className="placeholder bg-secondary rounded col-7" ></span>
                                <span className="placeholder bg-secondary rounded col-5" ></span>
                                <span className="placeholder bg-secondary rounded col-8" ></span>
                                <span className="placeholder bg-secondary rounded col-4" ></span>
                                <span className="placeholder bg-secondary rounded col-5" ></span>
                                <span className="placeholder bg-secondary rounded col-7" ></span>
                                <span className="placeholder bg-secondary rounded col-3" ></span>
                                <span className="placeholder bg-secondary rounded col-2" ></span>
                                <span className="placeholder bg-secondary rounded col-8" ></span>
                            </div>
                        </div>

                    </div>
                </div>
            }
             <ToastSuccess show={showToastSuccess} closeFc={setShowToastSuccess} message='บันทึกแล้ว' />
            <ToastError show={showToastError} closeFc={setShowToastError} message={'เกิดข้อผิดพลาด!!'} />
        </Layout4Admin1>
    )
}